import React, { createContext, useContext, useState } from "react";

const HomeTabContext = createContext(null);

export const HomeTabProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <HomeTabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </HomeTabContext.Provider>
  );
};

export const useHomeTab = () => useContext(HomeTabContext);

export const HOME_TABS = ["Opioid", "Prostate Cancer", "Mental Health"];

export const TAB_DISEASE_TYPES = ["opioid", "prostate_cancer", "mental_health"];

// Mental Health is not wired up to a backend yet — keep its tab visible but disabled until it is.
export const HOME_TABS_DISABLED = [false, false, true];
